'use client'

import {useAtomValue, useSetAtom} from "jotai";
import {configurationState} from "@/components/Atoms/ConfigurationAtom";
import {templatesState} from "@/components/Atoms/TemplatesAtom";
import {useQuery} from "react-query";
import {getTemplates} from "@/lib/fetch/templates/getTemplates";
import {userState} from "@/components/Atoms/UserAtom";
import {useEffect} from "react";
import {notifyError} from "@/lib/reporting/notifyError";

export function GetAndSaveTemplates() {

    const configuration = useAtomValue(configurationState)
    const user = useAtomValue(userState)
    const setTemplates = useSetAtom(templatesState)

    const {data} = useQuery(['templates'], () => getTemplates(configuration, user.securityToken), {
        staleTime: 60000,
        enabled: !!(configuration?.config && user.securityToken),
    })

    useEffect(() => {
        if (data?.data?.templates) {

            // Filter templates that doesnt have skeleton id
            let templatesToRegister =  [...data.data.templates.filter(template => {
                if (template.skeletonId) { return template }
            })]

            // Set active props from admin configuration
            templatesToRegister = templatesToRegister.map(template => {
                const configuration = JSON.parse(template.configuration)
                // Catch legacy template configuration with not translations (used to be an object)
                if (!Array.isArray(configuration)) {
                    notifyError('Template configuration is not an array, template id : ' + template.id)
                    return
                }
                const isActive = template.isActive ?? false
                return {...template, isActive: isActive ?? false}
            })

            // If needed, remove all undefined from templates (undefined because of a bad configuration, see above)
            templatesToRegister = templatesToRegister.filter(template => template !== undefined)

            setTemplates(templatesToRegister)
        }
    }, [data]);



    return null

}